import {
  requiredText,
} from "@/services/schemas/genericSchemas";
import * as Yup from "yup";

export const AppointmentInitialValues = {
  id: 0,
  calendarId: "",
  calendarLocationId: "",
  customLocation: "",
  title: "",
  participantId: "",
  leadId: 0,
  notes: "",
  timeZone: "",
  startDate: "",
  endDate: "",
  email: "",
  date: "",
  slot: "",
};


export const AppointmentSchema = Yup.object().shape({
  calendarId: requiredText,
  title: requiredText,
  leadId: Yup.mixed()
    .required("Please select a lead")
    .test("is-valid-lead", "Please select a lead", (value) => {
      if (value === undefined || value === null || value === "") return false;
      if (typeof value === "number") {
        return value > 0;
      }
      const parsed = Number(value);
      if (!isNaN(parsed)) {
        return parsed > 0;
      }
      return String(value).trim() !== "" && String(value).trim() !== "0";
    }),
  timeZone: requiredText,
  startDate: requiredText,
  endDate: requiredText,
  date: requiredText,
  participantId: requiredText,
});
